// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__1jAma","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__11LYT"};